// frontend/library-ui/src/types/event.ts
// 该文件用于定义与后端 Event 模型匹配的前端数据结构
// 根据 /shared/models/event.py 创建

/**
 * 事件来源枚举
 * 对应后端 /shared/models/event.py 中的 EventSource
 */
export enum EventSource {
  DEVICE = "device",
  FRONTEND = "frontend",
  SERVER = "server",
  SYSTEM = "system",
}

/**
 * 事件状态枚举
 * 对应后端 /shared/models/event.py 中的 EventStatus
 */
export enum EventStatus {
  ACTIVE = "active",
  ENDED = "ended",
  FAILED = "failed",
  CANCELLED = "cancelled",
  SYSTEM_TIMEOUT = "system_timeout",
  ADMIN_FORCED_END = "admin_forced_end",
}

/**
 * 事件数据接口
 * 对应后端 /shared/models/event.py 中的 Event 模型
 */
export interface Event {
  id: number;
  event_id: string;
  device_id: string;
  room_id: string;
  contact_name: string | null;
  event_source: EventSource;
  start_time: string; // ISO 8601 date string
  end_time: string | null; // ISO 8601 date string
  status: EventStatus;
  event_metadata: Record<string, unknown> | null;
  created_at: string; // ISO 8601 date string
  updated_at: string; // ISO 8601 date string
}
